import styles from './OrderMapItem.module.css'
import ModalWindow from "../../../FormTemplate/ModalWindow/ModalWindow";
import MainFormTemplate, {IRefMainFormTemplate} from "../../../FormTemplate/MainFormTemplate/MainFormTemplate";
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../../ApiQuery/UseApiQuery";
import ButtonContainer from "../../../FormTemplate/ButtonContainer/ButtonContainer";
import ErrorLineItem, {ErrorLineItemRef} from "../../../FormTemplate/ErrorLineItem/ErrorLineItem";
import moment from 'moment';
import InputItem from "../../../FormTemplate/InputItem/InputItem";
interface IOrderMapItemProps
{
    orderId: string
    regMode:number
    state: number
    onClose: (mode:number)=>void
    tempCtn?:string
    ctn?:string
}


interface ICurProcessUnit
{
    process:number
    selectedCode: number
}

interface ICurProcessDeliveryUnit
{
    process:number
    selectedCode: number
    deliveryName:string
    customerId:number
}


interface IOrderSubStateItem
{
    code:number
    name:string
    order:number
    desc:string
    sendSms:boolean

}
interface IOrderState
{
    code:number
    name:string
    desc:string
    subStateList: IOrderSubStateItem[]
}
interface IHistoryItem
{
    id:number
    orderId:string
    state: number
    mapId:number
    text: string
    userId: string
    tm: string
    addInfo:string
}


interface IAddOrderState
{
    orderId:string

     mapState:{
        processCode: number
        itemCode: number
     }

     deliveryState:{
        processCode: number
        itemCode: number
     }

     notify:{
        sms: boolean
        history: boolean
        lk: boolean
        eMail:boolean
     }

    notifyBundle:{
        map:boolean
        delivery:boolean
    }


     addInfo?:string


}


export default function OrderMapItem({orderId, regMode, onClose,state,ctn,tempCtn}:IOrderMapItemProps)
{
    const [map, setMap] = useState<ICurProcessUnit>({process: -1,selectedCode: -1})
    const [delivery, setDelivery] = useState<ICurProcessDeliveryUnit>({process: -1,selectedCode: -1,deliveryName:"Не известно",customerId:-1})

    const refDownSide = useRef<ErrorLineItemRef>(null)

    const [needUpdate, setNeedUpdate] = useState(false)
    const [closed, setClosed] = useState(false)


    const dataOrderState = useRef()
    const [ldrOrderState,rsOrderState,exOrderState] = useApiQuery("/ref/order/state/list","get",dataOrderState);
    const [orderState, setOrderState] = useState<IOrderState[]>([])


    const dataOrderStage = useRef<{
        orderId:string
    }>()
    const [ldrOrderStage,rsOrderStage,exOrderStage] = useApiQuery("/order/process/state","post",dataOrderStage);

    const dataOrderClose = useRef<{
        orderId:string
        addInfo?:string
    }>()
    const [ldrOrderClose,rsOrderClose,exOrderClose] = useApiQuery("/order/process/close","post",dataOrderClose);


    const [notifyBox, setNotifyBox] = useState<{
        lk:boolean
        eMail:boolean
        sms:boolean
        history: boolean
    }>({lk: true,eMail: false, sms: false, history: true})

    const [notifyBundle, setNotifyBundle] = useState<{
        map:boolean
        delivery:boolean
    }>({map:true, delivery: false})


    const [moveDay, setMoveDay] = useState(0)

    const dataOrderHistory = useRef<{
        orderId:string
    }>()
    const [ldrOrderHistory,rsOrderHistory,exOrderHistory] = useApiQuery("/sell/sim/order/map","post",dataOrderHistory);
    const [orderHistory, setOrderHistory] = useState<IHistoryItem[]>([])

    const [addInfo,setAddInfo] = useState("")

    const dataOrderStateAdd = useRef<IAddOrderState>()
    const [ldrOrderStateAdd,rsOrderStateAdd,exOrderStateAdd] = useApiQuery("/order/process/state/add","post",dataOrderStateAdd );

    const dataOrderStateMove = useRef<{
        orderId:string
        moveDay:number
    }>()
    const [ldrOrderStateMove,rsOrderStateMove,exOrderStateMove] = useApiQuery("/order/process/state/move","post",dataOrderStateMove );


    const dataOrderHistoryDelete = useRef<{
        orderId:string
        id:number

    }>()
    const [ldrOrderHistoryDelete,rsOrderHistoryDelete,exOrderHistoryDelete] = useApiQuery("/sell/sim/order/map/delete","post",dataOrderHistoryDelete);


    const refMain = useRef<IRefMainFormTemplate>(null)



    useEffect(()=>{
        if(!orderId) return
        loadOrderStage()
        loadOrderStateList()
        loadOrderHistory()
    },[orderId])


    useEffect(()=>{

    },[orderState])

    useEffect(()=>{
        console.log("map", map, "delivery", delivery)
    },[map,delivery])





    const loadOrderStage = () =>{
        dataOrderStage.current = {orderId: orderId}
        exOrderStage().then((e)=>{
            if(e?.success)
            {
                console.log(e?.payload)
                const deliveryProcess = 33
                const deliveryCode = e?.payload?.deliveryOne?.state !==undefined ? e?.payload?.deliveryOne?.state : 0
                const deliveryName = e?.payload?.deliveryOne?.deliveryTypeOne?.name ? e?.payload?.deliveryOne?.deliveryTypeOne?.name : "Не известно"
                const customerId = e?.payload?.deliveryOne?.customerId ? e?.payload?.deliveryOne?.customerId : -1

                const stateProcess = e?.payload?.stateOne?.state !== undefined ? e?.payload?.stateOne?.state : -1
                const stateCode = e?.payload?.stateOne?.subState !== undefined ? e?.payload?.stateOne?.subState : -1

                setMap({process: stateProcess, selectedCode: stateCode})
                setDelivery({process: deliveryProcess, selectedCode: deliveryCode, deliveryName: deliveryName,customerId: customerId})

                return
            }
            if(refMain.current)refMain.current.state(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true, 4000)

        })
    }


    const loadOrderStateList = () =>{
        exOrderState().then((e)=>{
            if(e?.success)
            {
                setOrderState(e?.payload)
                return
            }
        })
    }
    const loadOrderHistory = () =>{
        dataOrderHistory.current = {
            orderId: orderId
        }
        exOrderHistory().then((e)=>{
            if(e?.success)
            {
                setOrderHistory(e?.payload)
                return
            }
        })
    }
    const handleMove = () =>{
        dataOrderStateMove.current ={
            orderId: orderId,
            moveDay: moveDay
        }
        exOrderStateMove().then((e)=>{
            if(e?.success)
            {
                const text = moveDay === 0 ? "Заказ востановлен" : `Заказ сдвинут на ${moveDay} дней`
                if(refMain.current)refMain.current.state(text, false, 4000)
                setNeedUpdate(true)
                loadOrderHistory()
                return
            }
            if(refMain.current)refMain.current.state(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true, 4000)

        })
    }

    const handleClose = ()=>{
        const quest = window.confirm("Вы уверены что хотите закрыть заказ?")
        if(! quest) return
        dataOrderClose.current = {orderId: orderId, addInfo: addInfo?.length ? addInfo : undefined}
        exOrderClose().then((e)=>{
            if(e?.success)
            {
                if(refMain.current)refMain.current.state("Заказ закрыт", false, 4000)
                setNeedUpdate(true)
                loadOrderHistory()
                setClosed(true)
                return

            }
            if(refMain.current)refMain.current.state(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true, 4000)

        })

    }

    const handleAdd= ()=>{

        if(map?.process === -1 || map?.selectedCode === -1 || delivery?.selectedCode === -1)
        {
            if(refMain.current)refMain.current.state("Выберите состояние заказа и доставки", true, 4000)
            return
        }
        dataOrderStateAdd.current = {
            orderId: orderId,
            addInfo: addInfo,
            mapState: {
                processCode: map?.process,
                itemCode: map?.selectedCode
            },
            deliveryState:{
                processCode: delivery?.process,
                itemCode: delivery?.selectedCode
            },
            notify:{
                eMail: notifyBox?.eMail,
                sms: notifyBox?.sms,
                lk: notifyBox?.lk,
                history: notifyBox?.history
            },
            notifyBundle:{
                map: notifyBundle?.map,
                delivery: notifyBundle?.delivery
            },

        }
        exOrderStateAdd().then((e)=>{
            if(e?.success)
            {
                if(refMain.current)refMain.current.state(e?.payload?.text ? e?.payload?.text : "Статус добавлен", false, 6000)
                loadOrderHistory()
                setNeedUpdate(true)

                return
            }
            if(refMain.current)refMain.current.state(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true, 4000)
        })
    }




    const buildDeliveryItem = (code: number) =>{
        if(delivery?.customerId === 5 )return null
        const x = orderState?.filter((item)=>item?.code === code)
        const process = x[0]
        const lines = process?.subStateList?.sort((a,b)=>a?.order - b?.order)
        const lk = lines?.map((item, idx)=>{
            return(
                <div
                    className={[styles.piItem, styles.piItemV, delivery?.selectedCode === item?.code ? styles.piItemSelected: ""].join(' ')}
                    key={idx}
                    onClick={()=>setDelivery({...delivery,process:code, selectedCode: item?.code})}

                >
                    {item?.name}
                    <div className={[item?.sendSms ? styles.piSms : "d-none"].join(' ')}>sms</div>
                </div>

            )
        })

        return(
            <div className={styles.pContV}>
                { false && <div className={styles.dlTitle}>{process?.name}</div>}
                <div className={styles.piContV}>
                    {lk}
                </div>
            </div>
        )


    }


    const buildProcessItem = (code : number)=>{
        const x = orderState?.filter((item)=>item?.code === code)
        if(x?.length === 0 )return null
        const process = x[0]

        const lines = process?.subStateList?.sort((a,b)=>a?.order - b?.order)
        const lk = lines?.map((item, idx)=>{
            const selected = map?.process === code && map?.selectedCode === item?.code
            console.log(`process ${code} -> ${item?.name} ${item?.sendSms} ${tempCtn} ${ctn}`)
            let descText = item?.desc ?  item?.desc : ""
            if(tempCtn)descText = descText?.replaceAll(/\{\{tempCtn\}\}/uig,tempCtn)
            if(ctn)descText = descText?.replaceAll(/\{\{ctn\}\}/uig,ctn)

            return(
                <div
                    className={[styles.piItem, selected ? styles.piItemSelected: ""].join(' ')}
                    key={idx}
                    onClick={()=>{
                        setMap({process:code, selectedCode: item?.code})
                        setAddInfo(descText)
                    } }

                >
                    {item?.name}
                    <div className={[item?.sendSms ? styles.piSms : "d-none"].join(' ')}>sms</div>
                </div>
            )
        })

        return(
            <div className={styles.pCont}>
                <div>{process?.name}</div>
                <div className={styles.piCont}>
                    {lk}
                </div>
            </div>
        )

    }

    const buildMap_modeMnp = () =>{
        return(
            <div className={styles.stRowContX}>
                <div className={styles.stColumn}>
                    {buildProcessItem(50)}
                </div>
                <div className={styles.stColumn}>
                    {buildProcessItem(1)}
                </div>
                <div className={styles.stColumn}>
                    {buildProcessItem(2)}
                </div>
                <div className={styles.stColumn}>
                    {buildProcessItem(3)}
                </div>
                <div className={styles.stColumn}>
                    {buildProcessItem(5)}
                </div>
                <div className={styles.stColumn}>
                    {buildProcessItem(40)}
                </div>
            </div>
        )
    }

    const buildMap_modeSelf = () =>{
        return(
            <div className={styles.stRowContX}>
                <div className={styles.stColumn}>
                    {buildProcessItem(50)}
                </div>
                <div className={styles.stColumn}>
                    {buildProcessItem(1)}
                </div>
                <div className={styles.stColumn}>
                    {buildProcessItem(6)}
                </div>
                <div className={styles.stColumn}>
                    {buildProcessItem(40)}
                </div>
            </div>
        )
    }


    const buildMap = () =>{
        let x = null
        if(regMode === 10) x =  buildMap_modeMnp()
        if(regMode === 1 || regMode ===2) x =buildMap_modeSelf()
        if(regMode === 0) x =buildMap_modeSelf()


        if(!x)return (
            <div>Не известный режим продажи</div>
        )
        return (
                <div className={styles.stRowCont}>
                    {x}
                    {tempCtn && tempCtn?.length > 5 &&
                        <div className={styles.aInfo}
                             onClick={async ()=>await navigator.clipboard.writeText(tempCtn ? tempCtn : "-")}
                        >Временный номер : <span>{tempCtn ? tempCtn : "-"}</span></div>
                    }
                    {ctn && ctn?.length > 5 &&
                        <div className={styles.aInfo}
                             onClick={async ()=>await navigator.clipboard.writeText(ctn ? ctn : "-")}
                        >Номер : <span>{ctn ? ctn : "-"}</span></div>
                    }

                    <InputItem
                        val={addInfo}
                        mode={"ie"}
                        title={"Дополнительная информация"}
                        titleShift={-6}
                        lineCount={3}
                        inputType={2}
                        info={"Доролнительная информация по статусу"}
                        onChange={(e)=> setAddInfo(e)}
                    />
                </div>
        )

    }


    const handleDelete = (id: number) =>{
        const quest = window.confirm("Вы уверены что хотите удалить запись?")
        if(! quest) return
        dataOrderHistoryDelete.current = {
            orderId: orderId,
            id:id
        }
        exOrderHistoryDelete().then((e)=>{
            if(e?.success)
            {
                if(refMain.current)refMain.current.state("Статус удален", false, 4000)
                loadOrderHistory()
                return
            }
            if(refMain.current)refMain.current.state(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true, 4000)

        })
    }


    const buildDelivery = () =>{
        if(delivery?.selectedCode === -1) return null
        return (
            <div className={styles.stRowCont}>
                <div className={styles.dvName}>{delivery?.deliveryName}</div>
                <div className={styles.dlCont}>
                    {buildDeliveryItem(33)}

                </div>
            </div>
        )
    }

    const _buildHistory = () =>{
        const x = orderHistory?.map((item,idx)=>{
            const len = orderHistory?.length
            return (
                <div className={styles.hRow} key={idx}>

                    <div className={styles.xAct} onClick={()=>handleDelete(item?.id)}><i className='bx bx-trash'></i></div>
                    <div className={styles.hItem}>[{len-idx}]</div>
                    <div className={styles.hItem}>{item?.userId}</div>
                    <div className={styles.hItem}>{moment(item?.tm).format("DD.MM.YYYY HH:mm")}</div>
                    <div className={[styles.hItem, styles.hText].join(' ')}>{item?.text}</div>
                    <div className={[styles.hItem, styles.aText].join(' ')}>{item?.addInfo}</div>
                </div>
            )
        })
        return (
            <div className={styles.hCont}>
                {x}

            </div>
        )
    }
    const buildHistory = () =>{
        const x = orderHistory?.map((item,idx)=>{
            const len = orderHistory?.length
            return (
                <tr className={styles.hRow} key={idx}>

                    <td className={styles.xAct} onClick={()=>handleDelete(item?.id)}><i className='bx bx-trash'></i></td>
                    <td className={styles.hItem}>[{len-idx}]</td>
                    <td className={styles.hItem}>{item?.userId}</td>
                    <td className={styles.hItem}>{moment(item?.tm).format("DD.MM.YYYY HH:mm")}</td>
                    <td className={[styles.hItem, styles.hText].join(' ')}>{item?.text}</td>
                    <td className={[styles.hItem, styles.aText].join(' ')}>{item?.addInfo}</td>
                </tr>
            )
        })
        return (
            <div className={styles.hiTCont}>
                <div className={styles.hiTCont2}>
                    <table className={styles.hCont}>
                        <tbody>
                        {x}

                        </tbody>

                    </table>

                </div>

            </div>
        )
    }

    const buildMove = ()=>{
        return(
            <div className={styles.ntMain}>
                <div className={styles.ntContX}>
                    <i className='bx bx-chevron-left'
                        onClick={()=> {
                            setMoveDay(moveDay - 1 > 0 ? (moveDay-1): 0)
                        }}
                    />
                    <input className={"form-control form-control-sm"} value={moveDay} readOnly={true} onChange={()=>{}}/>
                    <i className='bx bx-chevron-right'
                       onClick={()=> {
                           setMoveDay(moveDay + 1 < 99  ? (moveDay+1): 99)
                       }}
                    />
                </div>
                <div className={styles.ntTitleZ}
                    onClick={handleMove}
                >отложить</div>
            </div>
        )
    }

    const buildNotify = () =>{
        return(
            <div className={styles.ntMain}>
                <div className={styles.ntTitleCont}>
                    <div className={styles.ntTitle}>Оповестить</div>
                    <div className={styles.ntItemCont}>
                        <div className={[styles.ntItemUnit, notifyBundle?.map ? styles.ntItemUnitSelected : ""].join(' ')}
                            onClick={()=> setNotifyBundle({...notifyBundle, map: !notifyBundle?.map})}
                        >статус</div>
                        <div className={[styles.ntItemUnit, notifyBundle?.delivery ? styles.ntItemUnitSelected : ""].join(' ')}
                             onClick={()=> setNotifyBundle({...notifyBundle, delivery: !notifyBundle?.delivery})}
                        >доставка</div>
                    </div>

                </div>

                <div className={styles.ntCont}>
                    <div className={styles.ntRow}>
                        <input className={["form-check-input"].join(' ')}
                               checked={notifyBox?.history}
                               onChange={()=>{
                                   setNotifyBox({... notifyBox, history: !notifyBox.history})
                               }}
                               type={"checkbox"}/><label>История</label>
                    </div>
                    <div className={styles.ntRow}>
                        <input className={["form-check-input"].join(' ')}
                               checked={notifyBox?.sms}
                               onChange={()=>{
                                   setNotifyBox({... notifyBox, sms: !notifyBox.sms})
                               }}
                               type={"checkbox"}/><label>SMS</label>
                    </div>
                    <div className={styles.ntRow}>
                        <input className={["form-check-input"].join(' ')}
                               checked={notifyBox?.lk}
                               onChange={()=>{
                                   setNotifyBox({... notifyBox, lk: !notifyBox.lk})
                               }}
                               type={"checkbox"}/><label>ЛК</label>
                    </div>
                    <div className={styles.ntRow}>
                        <input className={["form-check-input"].join(' ')}
                               checked={notifyBox?.eMail}
                               onChange={()=>{
                                   setNotifyBox({... notifyBox, eMail: !notifyBox.eMail})
                               }}

                               type={"checkbox"}/><label>EMail</label>
                    </div>
                </div>
            </div>

        )
    }



    return(
        <ModalWindow>
            <MainFormTemplate title={`Карта заказа ${orderId}`} maxWidth={"1200px"} background={"white"} ref={refMain} refClone={refDownSide?.current}
                load={ldrOrderState || ldrOrderStateAdd || ldrOrderHistory || ldrOrderHistoryDelete}
            >
                <div className={"row"}>
                    {buildMap()}
                </div>
                <div className={"row"}>
                    {buildDelivery()}
                </div>
                <div className={"row"}>
                    <div className={styles.rHis}>История статусов</div>
                </div>
                <div className={"row"}>
                    {buildHistory()}
                </div>

                <ButtonContainer my={10} resize={true}>
                    {buildNotify()}
                    <div className={styles.bdCont}>
                        <ErrorLineItem ref={refDownSide}></ErrorLineItem>
                    </div>
                    {buildMove()}
                    <button type="button" className={["btn btn-secondary ", styles.redButton].join(' ')}
                            onClick={handleAdd}
                    >«+cтатус»</button>

                    <button type="button" className="btn btn-secondary "
                            onClick={handleClose}
                    >Закрыть заказ</button>


                    <button type="button" className="btn btn-secondary "
                            onClick={(e)=>{
                                if(closed){
                                    onClose(2)
                                    return
                                }
                                onClose( needUpdate ? 1: 0)
                            }}
                    >Отмена</button>

                </ButtonContainer>


            </MainFormTemplate>
        </ModalWindow>
    )
}